export default __webpack_public_path__ + "static/new-roma-2-039057b2988aa958b7f929a52a992fe3.jpg";